export default {
    GIFT_CARD_PRICE_CONFIG              : 'gift_card_price_config',
    GIFT_CARD_TYPE                      : "gift_card_type",
    GIFT_CARD_TYPE_PHYSICAL             : 1,
    GIFT_CARD_TYPE_VIRTUAL              : 2,
    GIFT_CARD_TYPE_COMBINE              : 3,
    GIFT_PRICE                          : "gift_price",
    GIFT_PRICE_TYPE                     : "gift_price_type",
    GIFT_PRICE_TYPE_SAME_GIFT_CARD_VALUE: 1,
    GIFT_PRICE_TYPE_FIXED               : 2,
    GIFT_PRICE_TYPE_PERCENT             : 3,
    GIFT_TYPE                           : "gift_type",
    GIFT_TYPE_FIXED_VALUE               : 1,
    GIFT_TYPE_RANG_OF_VALUES            : 2,
    GIFT_VALUE                          : "gift_value",
    GIFT_VALUE_FROM                     : "gift_from",
    GIFT_VALUE_TO                       : "gift_to",
    GIFT_TYPE_DROPDOWN_VALUES           : 3,
    GIFT_DROPDOWN_VALUE                 : "gift_dropdown",

    GIFT_CARD_AMOUNT        : 'amount',
    GIFT_CARD_TEMPLATE_ID   : 'giftcard_template_id',
    GIFT_CARD_TEMPLATE_IMAGE: 'giftcard_template_image',

    GIFT_CARD_MESSAGE          : 'message',
    GIFT_CARD_CUSTOMER_NAME    : 'customer_name',
    GIFT_CARD_RECIPIENT_NAME   : 'recipient_name',
    GIFT_CARD_RECIPIENT_EMAIL  : 'recipient_email',
    GIFT_CARD_RECIPIENT_SHIP   : 'recipient_ship',
    GIFT_CARD_SEND_FRIEND      : 'send_friend',
    GIFT_CARD_DAY_TO_SEND      : 'day_to_send',
    GIFT_CARD_TIMEZONE_TO_SEND : 'timezone_to_send',
    GIFT_CARD_RECIPIENT_ADDRESS: 'recipient_address',
    GIFT_CARD_NOTIFY_SUCCESS   : 'notify_success',

//    intergrade Giftcard Magento 2 EE
    GIFT_CARD_M2EE_CUSTOM_AMOUNT  : 'custom_giftcard_amount',
    GIFT_CARD_M2EE_AMOUNT         : 'giftcard_amount',
    GIFT_CARD_M2EE_SENDER_NAME    : 'giftcard_sender_name',
    GIFT_CARD_M2EE_RECEIPIENT_NAME: 'giftcard_recipient_name',
    GIFT_CARD_M2EE_SENDER_EMAIL   : 'giftcard_sender_email',
    GIFT_CARD_M2EE_RECIPIENT_EMAIL: 'giftcard_recipient_email',
    GIFT_CARD_M2EE_MESSAGE        : 'giftcard_message',
}



// WEBPACK FOOTER //
// ./src/view/constant/catalog/GiftCardProductConstant.js